export default __webpack_public_path__ + "static/media/feature_1.201d6f49.png";